"use strict";

var from         = require("es5-ext/array/from")
  , primitiveSet = require("es5-ext/object/primitive-set");

module.exports = primitiveSet.apply(
	null,
	from(
		" \f\t\v​\u00a0\u1680​\u180e" +
			"\u2000​\u2001\u2002​\u2003\u2004​\u2005\u2006​\u2007\u2008​\u2009\u200a" +
			"​​​\u202f\u205f​\u3000"
	)
);
